export default {
  fr: { close: 'Fermer' },
  en: { close: 'Close' },
  'pt-br': { close: 'Fechar' },
  es: { close: 'Cerrar' },
  de: { close: 'Schließen' },
} as const
